import type { TestCase, TestSuite } from '../api'

const VERIFY_REGEX = /\[VERIFY:[^\]]*\]/

/** Check if a test case has any [VERIFY:...] tags in its expected results */
export function hasVerifyTags(tc: TestCase): boolean {
  return tc.steps.some((step) => VERIFY_REGEX.test(step.expected_result))
}

/** Count how many test cases in a suite have [VERIFY:...] tags */
export function getVerifyCount(suite: TestSuite): number {
  return suite.test_cases.filter((tc) => hasVerifyTags(tc)).length
}

/** Check if a single expected result string contains a [VERIFY:...] tag */
export function hasVerifyTag(text: string): boolean {
  return VERIFY_REGEX.test(text)
}

/**
 * Split expected result text into segments for rendering.
 * Returns an array of { text, isVerify } segments.
 */
export function splitVerifySegments(text: string): Array<{ text: string; isVerify: boolean }> {
  const segments: Array<{ text: string; isVerify: boolean }> = []
  let lastIndex = 0
  // Reset regex state
  const regex = /\[VERIFY:[^\]]*\]/g
  let match: RegExpExecArray | null

  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      segments.push({ text: text.slice(lastIndex, match.index), isVerify: false })
    }
    segments.push({ text: match[0], isVerify: true })
    lastIndex = regex.lastIndex
  }

  if (lastIndex < text.length) {
    segments.push({ text: text.slice(lastIndex), isVerify: false })
  }

  return segments
}
